var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (i18n, id, message, theme) {
      pug_mixins["icon"] = pug_interp = function(iconId, extraClassnames=''){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg" + (pug.attr("class", pug.classes(["icon",(extraClassnames !== '') ? extraClassnames : false], [false,true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003Cuse" + (pug.attr("xlink:href", `#${iconId}`, true, true)) + "\u002F\u003E\u003C\u002Fsvg\u003E";
};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["toast","align-items-center",(theme) ? theme : false], [false,false,true]), false, true)+pug.attr("id", id, true, true)+" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\"") + "\u003E\u003Cdiv class=\"d-flex text-white\"\u003E\u003Cdiv class=\"toast-body\"\u003E" + (null == (pug_interp = message) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cbutton class=\"btn btn-icon btn-sm btn-link-secondary me-2 m-auto\" type=\"button\" data-bs-dismiss=\"toast\"\u003E\u003Cspan class=\"visually-hidden\"\u003E" + (pug.escape(null == (pug_interp = i18n.btn_close_label) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
pug_mixins["icon"]('icon-close');
pug_html = pug_html + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "i18n" in locals_for_with ?
        locals_for_with.i18n :
        typeof i18n !== 'undefined' ? i18n : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "message" in locals_for_with ?
        locals_for_with.message :
        typeof message !== 'undefined' ? message : undefined, "theme" in locals_for_with ?
        locals_for_with.theme :
        typeof theme !== 'undefined' ? theme : undefined));
    ;;return pug_html;}

module.exports = template